import { Id } from "@supernova-studio/model";
import { DTOFeatureIteration, DTOFeatureIterationTag, DTOFeatureSandbox, } from "../forge";
import { DTOForgeProjectMember } from "../forge/project-member";
import z from "zod";
export const DTOForgeProjectMembersCreated = z.object({
    type: z.literal("ProjectMembersCreated"),
    data: z.array(DTOForgeProjectMember),
});
export const DTOForgeProjectMemberUpdated = z.object({
    type: z.literal("ProjectMemberUpdated"),
    data: DTOForgeProjectMember,
});
export const DTOForgeProjectMemberDeleted = z.object({
    type: z.literal("ProjectMemberDeleted"),
    data: DTOForgeProjectMember.pick({ userId: true }),
});
export const DTOForgeProjectIterationTagSet = z.object({
    type: z.literal("ProjectIterationTagSet"),
    data: DTOFeatureIterationTag,
});
export const DTOForgeProjectFeatureSandboxUpdated = z.object({
    type: z.literal("ProjectFeatureSandboxUpdated"),
    data: DTOFeatureSandbox,
});
export const DTOForgeProjectIterationUpdated = z.object({
    type: z.literal("ProjectIterationUpdated"),
    data: DTOFeatureIteration.extend({ featureId: Id }),
});
export const DTOForgeProjectRoomEvent = z.discriminatedUnion("type", [
    DTOForgeProjectMembersCreated,
    DTOForgeProjectMemberUpdated,
    DTOForgeProjectMemberDeleted,
    DTOForgeProjectIterationTagSet,
    DTOForgeProjectFeatureSandboxUpdated,
    DTOForgeProjectIterationUpdated,
]);
